export enum ROUTES {
  root = '/',
  about = '/about',
  login = '/login',
  profile = '/profile',
  register = '/register',
  search_pdf = '/search-pdf',
  pdf_history = '/pdf-history',
  documents_overview = '/documents',
  create_authorized = '/create-authorized',
  edit_authorized = '/edit-authorized',
  edit_original = '/edit-original',
}
